// extracted by mini-css-extract-plugin
export default {"catalogSearchBar":"cardCategory_catalogSearchBar__WC10P","catalogSearchField":"cardCategory_catalogSearchField__d+bav","catalogSearchTags":"cardCategory_catalogSearchTags__jn0T8"};